import {FC} from 'react'
import {Schema, schema, Labels, labels} from './schema'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {useDebouncedSubmit} from 'hooks/useDebouncedSubmit'
import {MainFormControls} from 'components/SearchForm/MainFormControls'
import {SearchTextBox} from 'components/SearchForm/SearchTextBox'
import styles from './SearchForm.scss'
import {SortingFields} from 'components/SearchForm/SortingFields'
import {FilterTag} from 'jbc-front/components/presenters/ui/FilterTag'

interface SearchFormProps {
  values: Schema
  onSubmit: (data: Schema) => void
  onClear: () => void
  hasConditions: (data: Schema) => boolean
  onChangeLimit: (limit: string) => void
}

export const SearchForm: FC<SearchFormProps> = ({values, onSubmit, onClear, hasConditions, onChangeLimit}) => {
  const methods = useForm<Schema>({
    values,
    resolver: yupResolver(schema),
  })
  const {handleSubmit, register, watch, setValue, subscribe} = methods

  const formValues = watch()
  const limits = ['10', '20', '50', '100', '200'].map((ele) => ({value: ele, label: `${ele}件を表示`}))

  const label = formValues.label as Labels

  useDebouncedSubmit(subscribe, () => handleSubmit(onSubmit)(), {
    ignoreAutoSubmitFields: ['per', 'label'],
  })

  return (
    <FormProvider {...methods}>
      <div className={styles.searchForm}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.mainSearchFields}>
            <MainFormControls isExpand={false} hasConditions={hasConditions(formValues)} onClear={onClear}>
              <SearchTextBox {...register('q')} style={{width: 230}} placeholder="検索キーワード" />
            </MainFormControls>
          </div>
          <div className={styles.sortingFieldsWrap}>
            <LabelField
              value={label}
              onChange={(value) => {
                if (label !== value) {
                  setValue('label', value)
                  handleSubmit(onSubmit)()
                }
              }}
            />
            <SortingFields
              limitName="per"
              limits={limits}
              sortTypes={[]}
              onChangeLimit={(newValue) => {
                onChangeLimit(newValue)
                handleSubmit(onSubmit)()
              }}
            />
          </div>
        </form>
      </div>
    </FormProvider>
  )
}

interface LabelFieldProps {
  value: Labels | undefined
  onChange: (value: Labels | undefined) => void
}

const LabelField: FC<LabelFieldProps> = ({value, onChange}) => {
  return (
    <div className={styles.labelField}>
      <FilterTag isActive={!value} onClick={() => onChange(undefined)}>
        <div className={styles.label}>すべて</div>
      </FilterTag>
      {labels.map((item) => (
        <FilterTag key={item.id} isActive={item.id === value} onClick={() => onChange(item.id)}>
          <div className={styles.label}>{item.name}</div>
        </FilterTag>
      ))}
    </div>
  )
}
